import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }

import AppLayout from "./layouts/AppLayout.vue";
import { useDeviceSettings } from "@/composables/useDeviceSettings";
import { useHeartbeat } from "@/composables/useHeartbeat";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

/**
 * アプリ起動時に
 *   - 端末表示設定の購読 (useDeviceSettings): localStorage を seed してから Firestore
 *     `terminals/{gateway_id}.deviceLocalSettings` を onSnapshot 購読。
 *   - 端末 heartbeat (useHeartbeat): 実機テレメトリ送信 ＋ 設定の初回 backfill。 ゲートで
 *     有効な端末/環境でのみ起動 (本番ドメイン＋解放端末)。
 * を開始する。
 */
useDeviceSettings();
useHeartbeat();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppLayout, null, {
      default: _withCtx(() => [
        _createVNode(_component_router_view)
      ]),
      _: 1
    })
  ]))
}
}

})